import React from "react";
import classNames from "classnames";
import { Image } from "semantic-ui-react";
import Logo from "assets/logo.svg";

const SystemPageContent = ({ title, className, children }) => (
  <div className={classNames("system-page-content", className)}>
    <section className="content-wrapper">
      <div className="logo-container">
        <Image src={Logo} alt="MaplesTeesdale" />
      </div>
      <div className="content-wrapper-content">
        {title && <h3>{title}</h3>}
        {children}
      </div>
    </section>
    <section className="background" aria-hidden="true" />
  </div>
);

export default SystemPageContent;
